<template>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-12 pt-3 pb-3 pl-4">
          <h3><i class="fas fa-paste"></i> Repositório de Anexos</h3>
        </div>
        <div>
          <small style="padding-left: 1.5rem;">Espaço total de repositório: 100mb.</small>
        </div>
      </div>
      <AttachmentList ref="ImportList" v-on:Upload="onUpload" />
    </div>
  </template>
<script>
import AttachmentList from '@/views/private/attachments/components/list/attachmentlist.vue'
import { loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools'

export default {
  name: 'Attachments',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    AttachmentList
  },
  methods: {
    onUpload () {
      this.showAdd = true
    },
    onBack () {
      loading.push()
      this.showAdd = false
      loading.close()
    },
    onLoad () {
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/attachments/attachments.vue